// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-edition .block .input[data-v-894a90e4] {
  color: var(--font-color);
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.contact-edition .block .edition-user-cont[data-v-894a90e4] {
  width: 100%;
  max-height: calc(var(--vh) * 100 - 200px);
  overflow-y: auto;
}
.contact-edition .block .edition-user-cont .edition-user-main[data-v-894a90e4] {
  display: flex;
  justify-content: space-between;
  text-align: right;
  height: 120px;
}
.contact-edition .block .edition-user-cont .edition-user-main .edition-user-foto[data-v-894a90e4] {
  width: 110px;
  height: 110px;
  margin-left: 25px;
  position: relative;
}
.contact-edition .block .edition-user-cont .edition-user-main .edition-user-name[data-v-894a90e4] {
  flex-grow: 1;
}
.contact-edition .block .edition-user-cont .edition-user-main .edition-user-name .edition-user-name-input[data-v-894a90e4] {
  display: flex;
  justify-content: flex-end;
}
.contact-edition .block .edition-user-section-single[data-v-894a90e4] {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px;
  font-weight: inherit;
}
.contact-edition .block .edition-user-section-single span[data-v-894a90e4] {
  margin-left: 30px;
  font-weight: bold;
  padding-top: 3px;
  width: 135px;
}
.contact-edition .block .edition-user-section-single .edition-user-section-input[data-v-894a90e4] {
  display: flex;
  position: relative;
}
.contact-edition .block .edition-user-section[data-v-894a90e4] {
  display: flex;
  justify-content: space-between;
}
.contact-edition .block .edition-user-section .edition-user-section-label[data-v-894a90e4] {
  display: flex;
}
.contact-edition .block .edition-user-section .edition-user-section-label[data-v-894a90e4] .custom-input-wrapper .div-textarea {
  border-bottom: none;
}
.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set[data-v-894a90e4] {
  width: 25px;
  text-align: center;
  margin-right: 5px;
  padding-top: 5px;
}
.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set i[data-v-894a90e4] {
  color: #aaa;
  font-size: 13px;
  padding: 4px;
  border-radius: 2px;
  cursor: pointer;
}
.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set i[data-v-894a90e4]:hover {
  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;
  color: #000;
}
.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-label-name[data-v-894a90e4] {
  width: 150px;
}
.contact-edition .block .edition-user-section .edition-user-section-input[data-v-894a90e4] {
  display: flex;
  position: relative;
}
[data-v-894a90e4] .footer {
  display: flex;
  justify-content: space-between;
}
[data-v-894a90e4] .footer .btns-service {
  display: flex;
  justify-content: flex-start;
}
[data-v-894a90e4] .footer .btns-func {
  display: flex;
  justify-content: flex-end;
}
.global-value-btn[data-v-894a90e4] {
  width: 25px;
  padding-top: 5px;
  text-align: center;
  opacity: .5;
}
.global-value-btn i[data-v-894a90e4] {
  font-size: 13px;
  padding: 4px;
  border-radius: 2px;
  cursor: pointer;
}
.global-value-btn i[data-v-894a90e4]:hover {
  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;
  opacity: .3;
}
.input[data-v-894a90e4] {
  width: 185px;
  padding: 1px 0px;
  border: none;
  outline: none;
  border-bottom: 1px solid #cccccc;
  min-height: 30px;
}
.input[data-v-894a90e4]:focus {
  border-bottom: 1px solid #165FCF;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/ContactProfoleEdition.vue"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,qDAAqD;AACvD;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb","sourcesContent":[".contact-edition .block .input[data-v-894a90e4] {\n  color: var(--font-color);\n  background-color: var(--bg-color);\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.contact-edition .block .edition-user-cont[data-v-894a90e4] {\n  width: 100%;\n  max-height: calc(var(--vh) * 100 - 200px);\n  overflow-y: auto;\n}\n.contact-edition .block .edition-user-cont .edition-user-main[data-v-894a90e4] {\n  display: flex;\n  justify-content: space-between;\n  text-align: right;\n  height: 120px;\n}\n.contact-edition .block .edition-user-cont .edition-user-main .edition-user-foto[data-v-894a90e4] {\n  width: 110px;\n  height: 110px;\n  margin-left: 25px;\n  position: relative;\n}\n.contact-edition .block .edition-user-cont .edition-user-main .edition-user-name[data-v-894a90e4] {\n  flex-grow: 1;\n}\n.contact-edition .block .edition-user-cont .edition-user-main .edition-user-name .edition-user-name-input[data-v-894a90e4] {\n  display: flex;\n  justify-content: flex-end;\n}\n.contact-edition .block .edition-user-section-single[data-v-894a90e4] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0px;\n  font-weight: inherit;\n}\n.contact-edition .block .edition-user-section-single span[data-v-894a90e4] {\n  margin-left: 30px;\n  font-weight: bold;\n  padding-top: 3px;\n  width: 135px;\n}\n.contact-edition .block .edition-user-section-single .edition-user-section-input[data-v-894a90e4] {\n  display: flex;\n  position: relative;\n}\n.contact-edition .block .edition-user-section[data-v-894a90e4] {\n  display: flex;\n  justify-content: space-between;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label[data-v-894a90e4] {\n  display: flex;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label[data-v-894a90e4] .custom-input-wrapper .div-textarea {\n  border-bottom: none;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set[data-v-894a90e4] {\n  width: 25px;\n  text-align: center;\n  margin-right: 5px;\n  padding-top: 5px;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set i[data-v-894a90e4] {\n  color: #aaa;\n  font-size: 13px;\n  padding: 4px;\n  border-radius: 2px;\n  cursor: pointer;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-btn-set i[data-v-894a90e4]:hover {\n  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;\n  color: #000;\n}\n.contact-edition .block .edition-user-section .edition-user-section-label .edition-user-label-name[data-v-894a90e4] {\n  width: 150px;\n}\n.contact-edition .block .edition-user-section .edition-user-section-input[data-v-894a90e4] {\n  display: flex;\n  position: relative;\n}\n[data-v-894a90e4] .footer {\n  display: flex;\n  justify-content: space-between;\n}\n[data-v-894a90e4] .footer .btns-service {\n  display: flex;\n  justify-content: flex-start;\n}\n[data-v-894a90e4] .footer .btns-func {\n  display: flex;\n  justify-content: flex-end;\n}\n.global-value-btn[data-v-894a90e4] {\n  width: 25px;\n  padding-top: 5px;\n  text-align: center;\n  opacity: .5;\n}\n.global-value-btn i[data-v-894a90e4] {\n  font-size: 13px;\n  padding: 4px;\n  border-radius: 2px;\n  cursor: pointer;\n}\n.global-value-btn i[data-v-894a90e4]:hover {\n  box-shadow: 1px 1px 1px #0000002e, 0px 0px 1px #0000002e;\n  opacity: .3;\n}\n.input[data-v-894a90e4] {\n  width: 185px;\n  padding: 1px 0px;\n  border: none;\n  outline: none;\n  border-bottom: 1px solid #cccccc;\n  min-height: 30px;\n}\n.input[data-v-894a90e4]:focus {\n  border-bottom: 1px solid #165FCF;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
